export enum ActivateOnglets {
  AUTH = 'AUTHENTIFIED',
  ID = 'IDENTIFIED',
  ENABLE = 'ENABLED',
}
